var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1242,
    height: 947,
    viewBox: "0 0 1242 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1242 0V957.245C1155.61 988.903 1018.17 1002.04 940.063 1003.79C835.1 1006.16 747.002 987.978 700.984 966.625C616.868 927.581 657.537 863 585.151 858.5C573.311 856.503 538.11 858.668 506.233 863C463.547 872 431.05 872 412.566 872C394.082 872 357.686 856.745 338.035 836.029C308.631 805.036 295.684 751 295.684 698.275C308.641 615 306.634 636.583 333.88 552.333C337.449 541.306 345.259 516.316 342.236 483.966C340.526 466.125 335.878 448.759 328.513 432.688C328.513 432.688 327.726 431.221 326.861 429.849C300.923 388.61 229.91 366.368 229.91 366.368C164.846 345.988 152.602 326.49 132.97 279.381C127.382 265.966 112.159 226.056 130.749 154.429C163.918 26.612 0 0.00532228 0 0.00532228L1242 0Z",
    fill: "url(#paint0_linear_91_2357)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_2357",
    x1: 324.075,
    y1: 15.2783,
    x2: 518.335,
    y2: 662.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0091CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/loginBg.6799722fb26f1a5d1db08d7d9a1aac13.svg";
export { ForwardRef as ReactComponent };